import { Box, Card, CardContent, IconButton, Stack, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

import MenuButton from '../../General/Menu/MenuButton/MenuButton';

interface MvpChatCardProps {
    title?: React.ReactNode;
    children: React.ReactNode;
    rightButtons?: React.ReactNode;
    menu?: React.ReactNode;
    style?: React.CSSProperties;
    highlightLeftBar?: boolean;
}

/**
 * Eine spezielle Card-Komponente für den MvpChatAgent mit höherem Header
 * Der Header nimmt nur 2/3 der Breite ein, damit der Chathistory-Bereich bis oben reichen kann
 */
const MvpChatCard: React.FC<MvpChatCardProps> = ({ title, children, rightButtons, menu, style, highlightLeftBar }) => {
    const theme = useTheme();
    const offline = useSelector((state: AppState) => state.client.offline);

    return (
        <Card
            elevation={0}
            sx={{
                position: 'relative',
                overflow: 'visible',
                boxShadow: 'none',
                display: 'flex',
                flexDirection: 'column',
                background: 'transparent',
                p: 0,
                borderRadius: 0,
                flexGrow: 1,
                ...style,
            }}
        >
            {highlightLeftBar && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '4px',
                        height: '100%',
                        bgcolor: theme.palette.primary.main,
                        borderTopLeftRadius: theme.shape.borderRadius,
                        borderBottomLeftRadius: theme.shape.borderRadius,
                    }}
                />
            )}

            {(title || menu || rightButtons) && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 1,
                        py: 1,
                        userSelect: 'none',
                        width: { xs: '100%', md: '100%' }, // Volle Breite auf Mobilgeräten, 2/3 auf Desktop
                    }}
                >
                    <Box
                        sx={{
                            flexGrow: 1,
                            textAlign: 'left',
                        }}
                    >
                        {title}
                    </Box>

                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        {!offline && menu && <MenuButton>{menu}</MenuButton>}
                        {rightButtons}
                    </Stack>
                </Box>
            )}

            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>{children}</CardContent>
        </Card>
    );
};

export default MvpChatCard;
